<template>
    <div
        v-if="authStore.impersonate || $can('impersonate', 'users')"
        class="absolute top-0 sm:left-1/2 sm:-translate-x-1/2 w-full sm:w-auto bg-amber-500 text-black z-[51] sm:p-1 shadow rounded rounded-t-none transform transition-transform"
        :class="{'translate-y-0':authStore.impersonate,'-translate-y-10':!authStore.impersonate}">
        <div class="flex text-xs font-bold justify-center">
            <div>
                <i18n-t keypath="users.impersonateBanner">
                    <template #organisation_name>
                        {{ authStore.userData?.organisation_name }}
                    </template>
                    <template #fullname>
                        {{ authStore.userData?.fullname }}
                    </template>
                </i18n-t>
            </div>
            <div class="ms-3 cursor-pointer">
                <span
                    v-if="!loading"
                    @click="leaveImpersonation">{{ $t('users.leaveImpersonationLink') }}
                </span>
                <span v-else><LoadingSpinner size="sm" /></span>
            </div>
        </div>
    </div>
</template>

<script setup>
import {useNuxtApp} from "nuxt/app"
import {useAuthStore} from "@/store/auth"
import {$larafetch} from "~/utils/$larafetch"

const authStore = useAuthStore()
const notification = useNotification()
const {t: $t} = useI18n()
const {$apiRoute} = useNuxtApp()

const loading = ref(false)

function leaveImpersonation() {
    loading.value = true
    $larafetch($apiRoute('spa.leaveImpersonation', {user: authStore.userData.id}))
        .then(response => {
            if (response === 'disabled') {
                notification.success($t('users.leaveImpersonationSuccess'))
                authStore.successfulLogin()
            }
        }).catch(() => {
            notification.error($t('users.leaveImpersonationError'))
        }).finally(() => {
            loading.value = false
        })
}
</script>